import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-3 items-center" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "group relative cursor-help" }
const _hoisted_5 = { class: "hidden group-hover:block overflow-hidden absolute top-0 right-0 -left-64 z-50 p-5 max-h-64 text-sm text-zinc-100 bg-zinc-800 rounded shadow-lg" }
const _hoisted_6 = { class: "font-normal" }

import { ChevronDownIcon, ChevronUpIcon, QuestionMarkCircleIcon } from '@heroicons/vue/outline';
import { Attribute } from '../types/Attribute';
import { Sort } from '../types/Sort';


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    sorted: { type: [Boolean, String] },
    description: null
  },
  emits: ["toggleSort"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggleSort', direction: Sort['direction']): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title: string
  sorted: false | 'asc' | 'desc'
  description?: Attribute['description']
}





function handleSort() {
  emit('toggleSort', props.sorted === 'asc' ? 'desc' : 'asc');
}

function lowerCaseFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "group flex flex-row gap-3 items-center cursor-pointer",
      onClick: handleSort
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ChevronUpIcon), {
          class: _normalizeClass(["-mb-1 w-4 h-4 group-hover:scale-150", {'fill-teal-300': __props.sorted === 'desc'}])
        }, null, 8, ["class"]),
        _createVNode(_unref(ChevronDownIcon), {
          class: _normalizeClass(["-mt-1 w-4 h-4 group-hover:scale-150", {'fill-teal-300': __props.sorted === 'asc'}])
        }, null, 8, ["class"])
      ]),
      _createElementVNode("div", null, _toDisplayString(__props.title), 1)
    ]),
    (__props.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(QuestionMarkCircleIcon), { class: "w-5 h-5" }),
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(__props.title) + ": ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(lowerCaseFirstLetter(__props.description)), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})